import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { PhoneCalls } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/PhoneCalls" component={PhoneCalls} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/PhoneCalls/routes.js